export const SET_SUBMISSIONS = "SET_SUBMISSIONS";
export const SET_SUBMISSION_DATA = "SET_SUBMISSION_DATA";
export const SET_SUBMISSION_ID = "SET_SUBMISSION_ID";
export const SET_INTERNAL_SUBMISSIONS = "SET_INTERNAL_SUBMISSIONS";
export const SET_COMPANY_DATA = "SET_COMPANY_DATA";
export const SET_SUBMISSION_DRAFT = "SET_SUBMISSION_DRAFT";
